// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".styles-module__FileHtmlLabel___1Rq5Z{display:none}.styles-module__FileHtmlLabel___1Rq5Z input{display:none}", "",{"version":3,"sources":["/tmp/build_9ddd188e/app/javascript/src/components/fields/FileInput/styles.module.scss"],"names":[],"mappings":"AAGA,sCACE,YAAA,CAEA,4CACE,YAAA","file":"styles.module.scss","sourcesContent":["@import \"../../../styles/mixins/index.scss\";\n@import \"../../../styles/variables/index.scss\";\n\n.FileHtmlLabel {\n  display: none;\n\n  input {\n    display: none;\n  }\n}\n"]}]);
// Exports
exports.locals = {
	"FileHtmlLabel": "styles-module__FileHtmlLabel___1Rq5Z"
};
module.exports = exports;
